const roofRidgeCoverBendedMetalSettings = {
    moveUpMm: -10,
    oneSideWidthMm: 400
}

export default roofRidgeCoverBendedMetalSettings
